import React from 'react';

interface CustomIconProps extends React.SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  fill?: string;
}

const LevelIcon: React.FC<CustomIconProps> = ({
  width,
  height,
  fill,
  ...rest
}) => {
  return (
    <svg
      width='22'
      height='20'
      viewBox='0 0 22 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M20.6572 8.83889L17.8281 7.42385C17.1289 7.07424 16.5508 6.49612 16.2012 5.79787L14.7861 2.96682C14.5645 2.52444 14.1192 2.25003 13.625 2.25003C13.1309 2.25003 12.6856 2.52444 12.4639 2.9678L11.0488 5.79787C10.6992 6.49611 10.1216 7.07424 9.42239 7.42385L6.5928 8.83889C6.14993 9.06057 5.87503 9.50492 5.87503 10C5.87503 10.4951 6.14993 10.9395 6.5928 11.1612L9.42239 12.5762C10.1216 12.9258 10.6992 13.5039 11.0488 14.2031L12.4639 17.0313C12.6856 17.4746 13.1299 17.749 13.625 17.749C14.1201 17.749 14.5645 17.4746 14.7861 17.0322L16.2012 14.2031C16.5508 13.5039 17.1289 12.9258 17.8272 12.5762L20.6582 11.1611C21.1006 10.9395 21.375 10.4942 21.375 10C21.375 9.50588 21.1006 9.06057 20.6572 8.83889ZM17.1563 11.2344C16.169 11.7285 15.3535 12.544 14.8594 13.5313L13.625 16L12.3906 13.5323C11.8965 12.545 11.081 11.7286 10.0933 11.2344L7.62451 10L10.0933 8.76566C11.081 8.27152 11.8965 7.4551 12.3906 6.4678L13.625 3.99906L14.8594 6.46878C15.3535 7.45608 16.169 8.27151 17.1572 8.76567L19.626 10L17.1563 11.2344ZM6.49507 17.2102L5.28242 17.8166C4.91853 17.9985 4.62348 18.2935 4.44154 18.6574L3.83522 19.8701C3.74861 20.0433 3.50142 20.0433 3.41481 19.8701L2.80849 18.6574C2.62654 18.2935 2.3315 17.9985 1.96761 17.8166L0.75496 17.2102C0.58168 17.1236 0.58168 16.8764 0.75496 16.7898L1.96761 16.1835C2.3315 16.0015 2.62655 15.7065 2.80849 15.3426L3.41481 14.13C3.50142 13.9567 3.74861 13.9567 3.83522 14.13L4.44154 15.3426C4.62349 15.7065 4.91853 16.0015 5.28242 16.1835L6.49507 16.7898C6.66835 16.8764 6.66835 17.1236 6.49507 17.2102ZM0.75496 2.78983L1.96761 2.18345C2.3315 2.0015 2.62655 1.70645 2.80849 1.34257L3.41481 0.129915C3.50142 -0.043305 3.74861 -0.043305 3.83522 0.129915L4.44154 1.34257C4.62349 1.70645 4.91853 2.00151 5.28242 2.18345L6.49507 2.78983C6.66835 2.87644 6.66835 3.12362 6.49507 3.21023L5.28242 3.81655C4.91853 3.9985 4.62348 4.29354 4.44154 4.65743L3.83522 5.87008C3.74861 6.0433 3.50142 6.0433 3.41481 5.87008L2.80849 4.65743C2.62654 4.29354 2.3315 3.99849 1.96761 3.81655L0.75496 3.21023C0.58168 3.12362 0.58168 2.87644 0.75496 2.78983Z'
        fill='#737373'
      />
    </svg>
  );
};

export default LevelIcon;
